// eslint-disable-next-line @nx/enforce-module-boundaries
import { PREPAID_SECURITY_CODE_LENGTH } from '@ocx/feat-add-payment-instrument';
import { maxLengthParser, onlyNumbersParser } from '../../../lib/form/utils';

export const parseSecurityCode = (value: string) =>
  maxLengthParser(onlyNumbersParser(value), PREPAID_SECURITY_CODE_LENGTH);
